export const GroupsConstants = {
    GROUPS_STATE: 'auth.application.detail.growth.groups',
    GROUP_DETAILS_STATE: 'auth.application.detail.growth.groups.group',
    GROUP_LIME_TYPE: 'application/vnd.lime.group+json',
    UPDATE_GROUP_LIME_TYPE: 'application/vnd.iris.whatsapp.update-group-resource+json',
    GROUPS_IDENTITY_SUFFIX: '.groups@wa.gw.msging.net',
    GROUP_MEMBER_LIME_TYPE: 'application/vnd.iris.whatsapp.group-member+json',
};
